import type { IconData } from '@stacksjs/iconify-core'

export const contentPin2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 6c0 1.144.32 2.214.876 3.124L0 14v2h2l4.876-4.876A6 6 0 1 0 4 6m6-4a4 4 0 0 0-4 4h1.5A2.5 2.5 0 0 1 10 3.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentPin2
